module.exports = __webpack_public_path__ + "img/salus.29758039.png";